import * as React from 'react';
import { colors } from '@styleseat/brand';

type StyleSeatTextLogoProps = {
  height?: number;
  width?: number;
  color?: string;
  testID?: string;
} & React.SVGProps<SVGSVGElement>;

export const StyleSeatTextLogo: React.FC<StyleSeatTextLogoProps> = ({
  height = 38,
  width = 71,
  color = colors.blackInBlack,
  testID,
  ...restProps
}: StyleSeatTextLogoProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 71 38"
    {...restProps}
  >
    <defs>
      <path id="prefix__a" d="M.005 0h14.708v37.995H.005z" />
      <path id="prefix__c" d="M.043 0h25.435v37.995H.043z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="prefix__b" fill="#fff">
        <use xlinkHref="#prefix__a" />
      </mask>
      <path
        fill={color}
        mask="url(#prefix__b)"
        d="M8.56 3.799h1.298v33.933h3.558V3.799h1.297V.269H8.561v3.53M3.97 3.536c.21 0 .377.16.398.362l.009 10.513h3.558L7.939 3.94C7.94 1.764 6.162 0 3.97 0 1.778 0 0 1.764 0 3.94L.005 14.41c0 2.502 1.489 4.221 2.737 5.807.894 1.19 1.634 2.313 1.634 3.37l-.009 10.514a.401.401 0 01-.398.362.401.401 0 01-.398-.362l-.009-10.513H.004L0 34.06C0 36.236 1.777 38 3.97 38c2.192 0 3.97-1.764 3.97-3.94L7.933 23.59c0-2.502-1.49-4.221-2.738-5.807-.893-1.19-1.632-2.313-1.632-3.37l.008-10.514a.401.401 0 01.398-.362"
      />
      <path
        fill={color}
        d="M19.958 23.589h-.617L18.86.268h-3.605L16.71 27.12h1.16v10.612h3.559V27.12h1.16L24.045.268h-3.605l-.48 23.32M62.993.269V3.8h2.19v33.933h3.558V3.799h2.19V.269h-7.938M31.146 37.731h6.155v-3.531h-2.597V20.765h1.98v-3.53h-1.98V3.799h2.598V.27h-6.156v37.463m16.288 0h5.655v-3.531h-2.097V20.765h1.981v-3.53h-1.98V3.799h2.597V.27h-6.156v37.463M28.357.268H24.8v37.464h5.539v-3.531h-1.98V.268"
      />
      <g transform="translate(38.115)">
        <mask id="prefix__d" fill="#fff">
          <use xlinkHref="#prefix__c" />
        </mask>
        <path
          d="M19.613 28.853l.74-25.054h.46l.74 25.054h-1.94zM17.393.268l-1.706 37.464h3.664l.158-5.348h2.148l.158 5.348h3.663L23.773.268h-6.38zM4.012 3.536c.21 0 .376.16.398.362l.008 10.513h3.558L7.982 3.94C7.982 1.764 6.205 0 4.012 0 1.82 0 .042 1.764.042 3.94L.049 14.41c0 2.502 1.488 4.221 2.737 5.807.894 1.19 1.633 2.313 1.633 3.37L4.41 34.103a.402.402 0 01-.398.362.401.401 0 01-.399-.362l-.008-10.513H.047L.043 34.06C.043 36.236 1.82 38 4.013 38c2.192 0 3.969-1.764 3.969-3.94L7.976 23.59c0-2.501-1.489-4.221-2.737-5.807-.894-1.19-1.633-2.313-1.633-3.37l.008-10.514a.401.401 0 01.399-.362"
          fill={color}
          mask="url(#prefix__d)"
        />
      </g>
    </g>
  </svg>
);
